import { deserialize, serialize, inheritSerialization, autoserializeAs } from "cerialize";
import BaseEntity from "../BaseEntity";
import TableColumn from "../TableColumn";
import TUKExpenseDetail from "./TUKExpenseDetail";
import moment from "moment";
import { getPenerimaDana } from "../../util/PluralVariabels";

@inheritSerialization(BaseEntity)
export default class TUKExpense extends BaseEntity {
    @serialize
    @deserialize
    public wilayah: string = "";

    @serialize
    @deserialize
    public bendahara_type: string = "";

    @serialize
    @deserialize
    public tanggal_pengeluaran: string = "";

    @serialize
    @deserialize
    public keterangan: string = "";

    @serialize
    @deserialize
    public total_nominal: number = 0;

    @autoserializeAs(TUKExpenseDetail)
    public details: TUKExpenseDetail[] = [];

    public wilayahFeedback() {
        return this.defaultPropertyFeedback('wilayah', Boolean(this.wilayah));
    }

    public tanggalPengeluaranFeedback() {
        return this.defaultPropertyFeedback('tanggal_pengeluaran', Boolean(this.tanggal_pengeluaran));
    }

    public table() {
        const {
            wilayah,
            bendahara_type,
            tanggal_pengeluaran,
            keterangan,
            total_nominal
        } = this;
        moment.locale('id');
        return {
            wilayah: getPenerimaDana(wilayah),
            bendahara_type: bendahara_type.replace('TUK_', '').replace(/_/g, ' '),
            tanggal_pengeluaran: moment(tanggal_pengeluaran).format('dddd, DD MMM YYYY'),
            keterangan,
            total_nominal,
        };
    }

    public static columnName(): Array<TableColumn> {
        const expense = new TUKExpense().table();
        let keys = Object.keys(expense);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            const labels: any = {
                wilayah: 'Wilayah',
                bendahara_type: 'Tipe Bendahara',
                tanggal_pengeluaran: 'Tanggal Pengeluaran',
                total_nominal: 'Total Nominal',
                keterangan: 'Keterangan'
            };
            tableColumn.name = labels[field] || field;
            return tableColumn;
        });
    }
}
